import { render, staticRenderFns } from "./PDialog.vue?vue&type=template&id=30c621f4"
import script from "./PDialog.vue?vue&type=script&lang=js"
export * from "./PDialog.vue?vue&type=script&lang=js"
import style0 from "./PDialog.vue?vue&type=style&index=0&id=30c621f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports